'use strict';

require('es6-promise').polyfill();

var React = require('react');
var $ = require('jquery');
var _ = require('lodash');
var ReactDOM = require('react-dom');
var Analytics = require('./../utils/Analytics');
var FlowModal = require('./../components/flow/Modal.react.js');
var ErrorLogger = require('./../utils/ErrorLogger');

// Object.assign poly
if (typeof Object.assign !== 'function') {
    Object.assign = _.assign;
}

// Configure jquery so that it automatically appends the csrf token in the HTTP header
// in all further ajax requests.
var token = $('#_csrf').val();
$.ajaxPrefilter(function (opts, origOpts, jqXHR) {
    jqXHR.setRequestHeader('X-CSRF-Token', token);
});

// setup Analytics
Analytics.setup();

module.exports = function (RootComponent) {
    // Read the data that the app needs
    var applicationData = $('.application-root').data('fields') || {};
    var appConfig = $('body').data('app-config') || {};
    var features = appConfig.features || {};

    applicationData.appConfig = appConfig;
    applicationData.features = features;

    if (features.log_client_error) {
        ErrorLogger.startTracking();
    }

    // finally render the application
    ReactDOM.render(
        <FlowModal
            // FlowModal needs to render the RootComponent of an app
            rootComponent={RootComponent}
            // FlowModal needs to pass applicationData as props to its RootComponent
            applicationData={applicationData}
            features={features}
            // To customise its container FlowModal for its specific needs, a RootComponent needs to pass props to it.
            // It needs applicationData to prepare these props.
            {...RootComponent.getFlowProps(applicationData)}
        />,

        $('.application-root').get(0)
    );
};



// WEBPACK FOOTER //
// ./public/js/flow/index.js